import React from "react";
import { STORE_INFO } from "../mock";

/**
 * A styled reproduction of the shop's yellow business card sticker.
 * Prop `rotate` allows a slight tilt for a more authentic pinned look.
 */
const BusinessCard = ({ rotate = "-rotate-3", className = "" }) => {
  return (
    <div className={`inline-block ${className}`}>
      <div
        className={`relative bg-[#fff447] text-neutral-900 px-8 py-6 shadow-2xl ${rotate} border border-yellow-500/30`}
        style={{
          boxShadow:
            "0 25px 50px -12px rgba(0,0,0,0.35), 0 0 0 1px rgba(0,0,0,0.05)",
          backgroundImage:
            "linear-gradient(135deg, #fff447 0%, #ffe605 100%)",
        }}
      >
        {/* Torn / folded corner effect */}
        <div className="absolute top-0 right-0 w-10 h-10 bg-gradient-to-br from-yellow-200 to-yellow-100 shadow-inner"
             style={{ clipPath: "polygon(100% 0, 0 0, 100% 100%)" }} />

        <div className="relative text-center">
          <h3 className="text-2xl md:text-3xl font-black tracking-tight leading-none">
            {STORE_INFO.name}
          </h3>
          <div className="mt-2 text-[13px] md:text-sm font-bold tracking-wide uppercase">
            {STORE_INFO.tagline}
          </div>
          <div className="mt-4 h-px w-24 bg-neutral-900/60 mx-auto" />
          <div className="mt-3 space-y-1 text-sm md:text-base font-semibold">
            <div>{STORE_INFO.address}</div>
            <div>Tél : {STORE_INFO.phone}</div>
            <div className="text-[12px] md:text-xs text-neutral-800/80 pt-1">
              Siret : {STORE_INFO.siret}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCard;
